import React, { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Paper, Typography, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ShapeIcon } from 'icons';
import { getLink } from 'helpers/routes';
import Avatar from 'shared/components/Avatar';
import { ROUTE_PROFILE_VIEW } from 'constants/routes';
import DisplayOn from 'shared/components/DisplayOn';
import Slider from 'shared/components/Slider';
import Heading from '../Heading';
import { useStyles } from './styles';

const Creators = () => {
	const { classes } = useStyles();
	const theme = useTheme();

	const awsBaseUrl = 'https://prod-blocksport-nft-data.s3.eu-central-1.amazonaws.com/assets/creatos/';

	const content = [
		{
			name: 'KK Partizan',
			description: 'Partizan has won 48 trophies and holds 21 national champion titles. They have also won 16 national basketball cups, 6 Adriatic championships and 1 ABA League Supercup, and most notably the European Champion trophy at the Final Four of the EuroLeague in Istanbul in 1992.',
			picture: `${awsBaseUrl}KK%20Partizan.png`,
			avatar: `${awsBaseUrl}KK%20Partizan_logo.png`,
			href: getLink(ROUTE_PROFILE_VIEW, { nickname: 'PartizanBC' }),
		},
		{
			name: 'Salford Red Devils',
			description: 'The Salford Red Devils are a professional rugby league club in Salford, Greater Manchester, England, that play in the Super League. Formed in 1873, they have won six Championships and one Challenge Cup.',
			picture: `${awsBaseUrl}Salford%20Red%20Devils.png`,
			avatar: `${awsBaseUrl}Salford%20Red%20Devils%20Logo.png`,
			href: getLink(ROUTE_PROFILE_VIEW, { nickname: 'SalfordRedDevils' }),
		},
		{
			name: 'Empoli FC',
			description: 'Italian football club based in Empoli. Founded in 1920, the side is part of a select group of Italian football clubs that do not belong to a provincial capital city that have participated in the top flight.',
			picture: `${awsBaseUrl}Empoli%20FC.png`,
			avatar: `${awsBaseUrl}Empoli%20FC%20Logo.png`,
			href: getLink(ROUTE_PROFILE_VIEW, { nickname: 'EmpoliCalcio' }),
		},
		{
			name: 'Red Star Belgrade RLC',
			description: 'Official account of Serbian Rugby League Champions Red Star Belgrade RLK.',
			picture: `${awsBaseUrl}Red%20Star%20Belgrade%20RLC.png`,
			avatar: `${awsBaseUrl}Red%20Star%20Belgrade%20RLC%20Logo.png`,
			href: getLink(ROUTE_PROFILE_VIEW, { nickname: 'RSBRLK' }),
		},
	];

	const CreatorsList = useMemo(() => {
		return content.map((item: any, idx: number) => (
			<Paper elevation={0} sx={{ width: 286 }} key={idx} component={RouterLink} to={item.href}>
				<Box>
					<Box mb={2} className={classes.imgBox}>
						<img src={item.picture} alt={item.name} />
					</Box>
					<Stack direction="row" spacing={1} alignItems="center">
						<Avatar src={item.avatar} alt={item.name} sx={{ width: 40, height: 40 }} />
						<Typography variant="h4">{item.name}</Typography>
						<ShapeIcon />
					</Stack>
					<Box mt={2}>
						<Typography variant="body1">{item.description}</Typography>
					</Box>
				</Box>
			</Paper>
		));
	}, [content]);

	return (
		<div className={classes.root}>
			<Heading label="Recommended Creators" />
			<Box mt={{ sx: 2, lg: 6 }}>
				<DisplayOn media={theme.breakpoints.between('xs', 'lg')}>
					<Slider>{CreatorsList}</Slider>
				</DisplayOn>
				<DisplayOn media={theme.breakpoints.up('lg')}>
					<Stack direction="row" spacing={4}>
						{CreatorsList}
					</Stack>
				</DisplayOn>
			</Box>
		</div>
	);
};

export default Creators;
